import "../components/html-panel";
import "../components/alert/alert";

import CCCHtmlPanel from "../components/html-panel";
import { getDomElement } from "../core/utilities";
import OContentModel from "../models/OContentModel";
import CCCAlert from "../components/alert/alert";
import UserModel from "../models/UserModel";
import VideoStatsModel from "../models/VideoStatsModel";
import { VanillaEvent } from "../core/interfaces/VanillaApi";

export interface EventReplayVideoControllerOptions {
  container: string;
  discussionId: string;
  isEditOrCreateMode?: boolean;
}
interface EventJson {
  event?: VanillaEvent;
}

export default class EventReplayVideoController {
  protected $eventDetailsContainer: HTMLElement = null;
  protected $separatorElement: HTMLElement = null;
  protected $htmlContainer: CCCHtmlPanel = null;
  private discussionId: string;

  async init(opts: EventReplayVideoControllerOptions): Promise<void> {
    if (opts.isEditOrCreateMode) return;

    this.$eventDetailsContainer = getDomElement(opts.container);
    this.discussionId = opts.discussionId;

    let alert = document.createElement("ccc-alert") as CCCAlert;

    alert.style.display = "block";
    alert.style.margin = "20px 0";

    if (this.$eventDetailsContainer) {
      try {
        const dates = document.querySelectorAll("time");
        const endDate = Date.parse(dates[1].dateTime);
        const currentDate = Date.now();

        if (endDate && currentDate > endDate) {
          // load video
          const videoString = await OContentModel.getEventVideoReplay(
            opts.discussionId
          );

          if (videoString !== "") {
            // create separator
            this.$separatorElement = this.createSeparator();

            // add video
            if (this.$eventDetailsContainer.querySelector("ccc-html-panel")) {
              return;
            }
            this.addVideo(videoString);

            alert = null;
          } else {
            console.log(
              "  EventReplayVideo - No video found for id: %s.",
              opts.discussionId
            );
            if (this.$eventDetailsContainer.querySelector("ccc-alert")) {
              return;
            }
            this.$eventDetailsContainer.appendChild(alert);
            alert.setState({
              text: "We’re working on the replay, please check back soon!",
              type: "info",
            });
          }
        }
      } catch (err) {
        this.$eventDetailsContainer.appendChild(alert);
        alert.setState({
          text: "Note: If a replay video is not loading, try refreshing the page or clear your browser cache/cookies. If that does not work, try using a different browser (there have been reported issues on Chrome.)",
        });
        console.error(err);
      }
    } else {
      console.log("  EventReplayVideo - Selector not found.");
    }
  }

  private addVideo(video: string) {
    if (this.$eventDetailsContainer && this.$separatorElement) {
      // load video
      this.$htmlContainer = document.createElement(
        "ccc-html-panel"
      ) as CCCHtmlPanel;
      this.$eventDetailsContainer.appendChild(this.$htmlContainer);
      this.$eventDetailsContainer.appendChild(this.$separatorElement);
      setTimeout(() => {
        this.$htmlContainer.setKeyState("html", video);
        this.$htmlContainer.loading = false;
        this.logVideoStatsOnPlay(this.$htmlContainer);
      }, 2000);
    }
  }

  private logVideoStatsOnPlay(videoContainer: HTMLElement) {
    const shadowRoot = videoContainer.shadowRoot;
    const panel = shadowRoot.querySelector("div");
    const kalturaPlayer: HTMLElement = panel.querySelector(
      "div > #kaltura_player"
    );

    kalturaPlayer.addEventListener("load", () => {
      const handleBlur = async () => {
        if (document.activeElement?.tagName === "CCC-HTML-PANEL") {
          const user = await UserModel.getCurrentUserCached();
          const eventJSON = await this.fetchEventJson();
          const categoryID = eventJSON?.event?.parentRecordID ?? null;

          const replayName = document.querySelector(
            ".pageTitleContainer .heading.heading-1"
          )?.textContent;

          const res = await VideoStatsModel.answerWatchedReplayPoll(
            this.discussionId,
            user.id,
            replayName,
            categoryID
          );
          console.debug("res: ", res);
          //Cleanup
          window.removeEventListener("blur", handleBlur);
          console.debug("Watched stats sent, listener removed...");
        }
      };
      window.addEventListener("blur", handleBlur);
    });
  }

  private async fetchEventJson(): Promise<EventJson> {
    const response = await fetch(`${window.location.href}.json`);
    return response ? response.json() : null;
  }

  private createSeparator(): HTMLElement | null {
    const separator = document.createElement("div");
    separator.setAttribute("class", "videoReplaySeparator");
    separator.setAttribute(
      "style",
      "border-bottom: 1px solid rgb(208, 208, 208); padding-top: 20px; padding-bottom: 20px;"
    );
    return separator as HTMLElement;
  }
}
